import 'imgix.js/dist/imgix.js';
import RailsEnv from '@frontend/app/features/RailsEnv';
import DebugLogger from '@frontend/app/features/DebugLogger';

import 'lazysizes';
import 'lazysizes/plugins/print/ls.print';

export default class ImgixHelper {
  static init() {
    this.logger = new DebugLogger(false); // NB: enable logging by setting false => true
    this.imgix.config.includeLibraryParam = false;

    // NB: Sometimes the computedWith is larger than necessary :/
    // we hook into the lazybeforesizes-event to check and optionally
    // overwrite the too-large computedWith
    document.addEventListener('lazybeforesizes', (event) => {
      const targetWidth = event.target.width;
      const computedWith = event.detail.width;
      event.detail.width = Math.min(computedWith, targetWidth);
    });

    this.refresh();
  }

  static get imgix() {
    return window.imgix;
  }

  static refresh() {
    this.imgix.init({
      host: window.ENV.imgix.source,
      srcAttribute: 'data-src',
      srcsetAttribute: 'data-srcset',
      sizesAttribute: 'data-ignored-sizes',
    });
    Array.from(
      document.querySelectorAll(
        '[ix-initialized=ix-initialized]:not(.lazyloaded):not([data-lazyload-initialized])'
      )
    ).forEach(
      function (imgTag) {
        imgTag.classList.add('lazyload');
        imgTag.dataset.lazyloadInitialized = true;
        imgTag.classList.remove('kr-lazysizes-placeholder');
        imgTag.onerror = this.getImgixErrorHandlerForEnvironment();
      }.bind(this)
    );
  }

  static getImgixErrorHandlerForEnvironment() {
    if (RailsEnv.isDev()) {
      return this.imgixHandlerForDevelopment;
    } else if (RailsEnv.isStaging()) {
      return this.imgixHandlerForStaging;
    }
  }

  static imgixHandlerForDevelopment() {
    var imgClone = this.cloneNode(true);
    imgClone.removeAttribute('srcset');
    imgClone.setAttribute('src', imgClone.getAttribute('ix-path'));
    this.parentNode.replaceChild(imgClone, this);
    return true;
  }

  static imgixHandlerForStaging() {
    ['src', 'srcSet'].forEach(
      function (attr) {
        this.setAttribute(
          attr,
          this.getAttribute(attr).replace(
            /staging-krautreporter.imgix.net/g,
            'krautreporter.imgix.net'
          )
        );
      }.bind(this)
    );
    return true;
  }
}
